/**
 * Manipulate a buffer after generating
 *
 * @abstract
 * @category Modifiers
 * @class Modifier
 */
class Modifier {
}
export { Modifier };
//# sourceMappingURL=Modifier.js.map